import TFormCheckboxInputs from './FormCheckboxInputs.vue'
import TFormCheckbox from './FormCheckbox.vue'

export const FormCheckboxInputs = TFormCheckboxInputs
export const FormCheckbox = TFormCheckbox
